import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const HadesehApiPath: IPaths = {
  BimehNamehHadesehEnferadi: {
    GetAllBimehNamehHayeHadesehEnferadiPagedFilter:
      'BimehNamehHadesehEnferadi/GetAllBimehNamehHayeHadesehEnferadiPagedFilter',
    GetAllShomarehBimehHayeHadesehEnferadi: 'BimehNamehHadesehEnferadi/GetAllShomarehBimehHayeHadesehEnferadi',
    GetPrintBimehNamehEnferadiDisplay: 'BimehNamehHadesehEnferadi/GetPrintBimehNamehHadesehEnferadiDisplay',
    GetBimehNamehHadesehEnferadiDetail: 'BimehNamehHadesehEnferadi/GetBimehNamehHadesehEnferadiDetail',
    BimehNamehHadesehEnferadiSaderShodeh: 'BimehNamehHadesehEnferadi/BimehNamehHadesehEnferadiSaderShodeh',
    CreateShenasehPardakht: 'BimehNamehHadesehEnferadi/CreateShenasehPardakht',
    AddToOrder: 'BimehNamehHadesehEnferadi/AddBimehNamehHadesehEnferadiToOrderWepod',
    Estelam: 'BimehNamehHadesehEnferadi/EstelamHadesehEnferadi',
    PrintBimehNamehEnferadi: 'BimehNamehHadesehEnferadi/PrintBimehNamehHadesehEnferadi',
    PrintElhaghiyehHadesehEnferadi: 'BimehNamehHadesehEnferadi/PrintElhaghiyehHadesehEnferadi',
    GetElhaghiyehHayeSadereh: 'BimehNamehHadesehEnferadi/GetElhaghiyehHayeSadereh',
    PrintBimehNamehHadesehEnferadiById: 'BimehNamehHadesehEnferadi/PrintBimehNamehHadesehEnferadiById',
  },
  TarhHayeHadesehEnferadi: {
    GetAllTarhHayeHadesehEnferadiNames: 'TarhHayeHadesehEnferadi/GetAllTarhHayeHadesehEnferadiNames',
  },
  KhatarTabiei: {
    GetActiveKhataratTabiei: 'KhatarTabiei/GetActiveKhataratTabiei',
  },
  PoosheshTarhHadesehEnferadi: {
    GetAllPoosheshHayeTarhHadesehEnferadi: 'PoosheshTarhHadesehEnferadi/GetAllPoosheshHayeTarhHadesehEnferadi',
  },
  PoosheshHadesehEnferadi: {
    GetActivePoosheshHayeHadesehEnferadi: 'PoosheshHadesehEnferadi/GetActivePoosheshHayeHadesehEnferadi',
  },
  TarhSodoor: {
    GetActiveTarhHayeSodoorByTarhHadesehEnferadi: 'TarhSodoor/GetActiveTarhHayeSodoorByTarhHadesehEnferadi',
  },
};
